/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMonitoringRentPlanDto } from '../../models/backend-monitoring-rent-plan-dto';

export interface MonitoringScenariosOpexesRentsList$Params {
  scenario_id: number;
}

export function monitoringScenariosOpexesRentsList(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringScenariosOpexesRentsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendMonitoringRentPlanDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringScenariosOpexesRentsList.PATH, 'get');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendMonitoringRentPlanDto>>;
    }),
  );
}

monitoringScenariosOpexesRentsList.PATH = '/api/monitoring/scenarios/{scenario_id}/opexes/rents/';
